module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn green-jungle pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveQuestion($event)
      }
    }
  }, [_vm._v("\n\tSalvar\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40d6541c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/evaluation/question-save/main.vue
// module id = 1056
// module chunks = 1